module.exports = __webpack_public_path__ + "static/media/5_10.a942ba82.png";